<template lang="pug">
v-card
  .pa-4
    h2.text-center.mb-4
      | Welcome to Nation.better!
    p.text-center.mb-4
      span
        | We are here to help you to apply
        | for a Sponsor Licence.

      br

      span
        | If you wish to apply
        | under Skilled Worker (T2) category
        | -
        | please press the button to proceed.

    div(style="margin-top: 50px")
      .d-flex.justify-center
        v-btn(color="primary", @click="dialogPrivacy = true")
          | skilled worker (T2)

        v-dialog(:value="dialogPrivacy", persistent, scrollable, width="500")
          v-card(style="width: 500px")
            v-card-title.headline 
              | Just to let you know…

            v-card-text
              br

              div
                b
                  | WE’RE IN BETA

              br

              div
                | Since Nation.better is a beta,
                | not everything will be perfect yet,
                | there might be some bugs
                | but we’re working in full speed
                | to roll out improvements and new features.
                | Let us know if you hit
                | any road bumps along the way.
                | The fun is in the journey!

              br

              div
                b
                  | IT’S YOUR DATA

              br

              div
                | All data you upload
                | to Nation.better platform
                | is 100% yours.
                | We’ll never share or make your data
                | or information available to anyone
                | without your explicit permission.

              br

              div
                b
                  | NO IMMIGRATION LEGAL ADVICE

              br

              div
                | Our platform contains
                | general information and guidance about
                | how to go through UK immigration processes.
                | You should not delay seeking legal advice,
                | disregard legal advice, or commence
                | or discontinue any legal action
                | because of information on our platform.
                | We are not giving
                | qualified immigration advice
                | unless you purchase our services,
                | then Primevisa Ltd
                | (qualified immigration advisor)
                | will provide you
                | with immigration legal advice
                | in respect to your case.
                | We will assist you with our own advice
                | as you use our services.

            v-card-actions
              v-spacer
              v-btn(text, color="primary darken-1", @click="$emit('next')")
                | continue

      //- .d-flex.justify-center.mt-2
        v-dialog(v-model="dialogOther", width="600")
          template(v-slot:activator="{ on }")
            v-btn(text, v-on="on")
              | other
          v-card
            .pa-4.text-center
              h3
                | We are currently providing services for companies
                br
                | who want to be Tier 2 General sponsor only
              p.mt-2
                | However, please let us know
                | what other categories you are interested in,
                br
                | and we will come back to you
              v-text-field(filled, label="Message", hide-details)
            v-card-actions
              v-spacer
              v-btn(text, @click="dialogOther = false")
                | close
              v-btn(color="primary")
                | send
</template>

<script>
export default {
  name: "welcome",

  data: () => ({
    dialogOther: false,
    dialogPrivacy: false,
    message: "",
  }),
};
</script>
